import React, { Fragment, FunctionComponent } from "react";
import NotFoundPageProps from "./NotFoundPageProps.interface";

import ContentPageBlock from "pages/ContentPage/ContentPage.block";

const NotFoundPage: FunctionComponent<NotFoundPageProps> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return <ContentPageBlock key={index} {...blockContent} />;
            })}
        </Fragment>
    );
};

export default NotFoundPage;